export default "https://cdn-static.gokick.com/assets/b4d66d8cd7eb0aaa0b454a3d41ce872cff261527/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";